<template>
  <div>
    <div style="background-color: #F5F5F5">
      <div>
        <v-btn class="mx-2 mt-2" color="primary" depressed @click="back">返回</v-btn>
        <v-btn color="primary" class="mr-2 mt-2" depressed v-if="appointment.status == 1 && _hasButtonPermission('审批')" @click="handleAudit">审批</v-btn>
      </div>
    </div>
    <v-card class="mt-2" elevation="0">
      <v-card-title>基础信息</v-card-title>
      <v-card-text>
        <v-row align="center" class="text-h6 ma-2">
          <v-col cols="4">
            供应商：{{appointment.venderName}}
          </v-col>
          <v-col cols="4">
            配送中心：{{appointment.parkName}}
          </v-col>
          <v-col cols="4">
            送货时间段：{{ appointment.sendStartTime }}~{{ appointment.sendEndTime }}
          </v-col>
          <v-col cols="4">
            月台范围：{{appointment.dockName}}
          </v-col>
          <v-col cols="2" v-if="appointment.addType == 2">
            总箱数：{{appointment.boxNum}}
          </v-col>
          <v-col cols="2" v-if="appointment.addType == 2">
            吨数：{{appointment.tonNum}}
          </v-col>
          <v-col cols="2" v-if="appointment.addType == 2">
            sku数：{{appointment.skuNum}}
          </v-col>
        </v-row>
        <div v-if="appointment.addType == 1 || appointment.addType == 3">
          <v-data-table :headers="orderHeaders" :items="appointment.orderList" hide-default-footer :items-per-page="-1">
            <template v-slot:item.actions="{ item,index }">
              <v-btn text color="primary" small @click="watchOrderGoods(item)">查看货品明细</v-btn>
            </template>
          </v-data-table>
        </div>
        <div v-if="appointment.addType == 2">
          <v-data-table :headers="goodsHeaders" :items="appointment.goodsList" hide-default-footer :items-per-page="-1"></v-data-table>
        </div>
      </v-card-text>
    </v-card>

    <v-card elevation="0">
      <v-card-title>装车信息</v-card-title>
      <v-card-text>
        <v-row align="center" class="text-h6 ma-2">
          <v-col cols="4">
            车牌号码：{{appointment.carNumber}}
          </v-col>
          <v-col cols="4">
            司机姓名：{{appointment.driver}}
          </v-col>
          <v-col cols="4">
            手机号码：{{ appointment.driverMobile }}
          </v-col>
          <v-col cols="4">
            卸货方式：{{appointment.dischargeName}}
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card elevation="0">
      <v-card-title>预约送达日期</v-card-title>
      <v-card-text>
        <v-row align="center" class="text-h6 ma-2">
          <v-col cols="4">
            {{ appointment.scheduledDate }} &nbsp;{{(appointment.timeType||appointment.timeType==0 )?appointment.timeType + '点-' + (appointment.timeType + 1) + '点' : '' }}
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card elevation="0">
      <v-card-title>审核信息</v-card-title>
      <v-card-text>
        <v-data-table :headers="auditHeaders" :items="appointment.auditRecordList" :items-per-page="-1" hide-default-footer>
          <template v-slot:item.auditResult="{ item,index }">
            {{auditResultList[item.auditResult - 1].name}}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="orderItem.dialog" width="1200">
      <v-card>
        <v-card-title>
          货品明细
        </v-card-title>
        <v-data-table :headers="orderItem.headers" :items="orderItem.item.itemList">
          <template v-slot:item.isComplete="{ item,index }">
            {{item.isComplete?'是':'否'}}
          </template>
        </v-data-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="orderItem.dialog = false"
          >
            取消
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="audit.dialog" width="400">
      <v-card>
        <v-card-title>
          请审核预约单信息
        </v-card-title>
        <v-card-text>
          <div class="text-center pa-2">
            <v-btn color="primary" @click="auditPass">通过</v-btn>
            <v-btn class="ml-10" @click="auditReject">拒绝</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="audit.failDialog" width="400">
      <v-card>
        <v-card-title>
          审核拒绝
        </v-card-title>
        <v-card-text>
          <v-form v-model="audit.form">
            <v-textarea outlined label="审核说明" v-model="audit.rejectReason" :rules="[audit.rules.required]"></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="audit.failDialog = false"
          >
            取消
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              @click="auditFail"
              :disabled="!audit.form"
          >
            确定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {default as ConfigApi} from "@/api/appointment/config/ConfigApi";
import AppointmentApi from "@/api/appointment/orders/AppointmentApi";

export default {
  name: "AppointmentView",
  props: {
    formData:{
      type:Object
    },
    buttonPriviledgeList: {
      type: Array,
      default: []
    }
  },
  data(){
    return {
      warning:'',
      appointment:{},
      orderHeaders:[
        {text: '订单号', align: 'start', width:120,sortable: false, value: 'ordercode',},
        { text: '货品数', value: 'goodsCount',width: 120, sortable: false,},
        { text: '总件数', value: 'innums' ,width: 120, sortable: false,},
        { text: '总数量', value: 'denums' ,width: 120, sortable: false,},
        { text: '未发货数量', value: 'undeliveryNums' ,width: 120, sortable: false,},
        { text: '本次发货货品数', value: 'deliveryCount' ,width: 120, sortable: false,},
        { text: '本次发货数量', value: 'deliveryNum' ,width: 120, sortable: false,},
        { text: '操作', value: 'actions', sortable: false, width:200 },
      ],
      goodsHeaders:[
        {text: '商品条码', align: 'start', width:120,sortable: false, value: 'barcode',},
        { text: '商品名称', value: 'goodsname',width: 120, sortable: false,},
        { text: '包装规格', value: 'packagespec',width: 120, sortable: false,filterable: true,},
        { text: '单位', value: 'pkname',width: 120, sortable: false,filterable: true,},
        { text: '本次发货数量', value: 'deliveryNum' ,width: 120, sortable: false,},
      ],
      orderItem:{
        item:{},
        dialog:false,
        completeList:[{id:1,name:'是'},{id:2,name:'否'}],
        headers:[
          {text: '商品名称', align: 'start', width:120,sortable: false, value: 'pn',},
          { text: '商品条码', value: 'barcode',width: 120, sortable: false,},
          { text: '总件数', value: 'innums' ,width: 80, sortable: false,},
          { text: '总数量', value: 'denums' ,width: 80, sortable: false,},
          { text: '未发件数', value: 'undeliveryInnums' ,width: 80, sortable: false,},
          { text: '未发数量', value: 'undeliveryDenums' ,width: 80, sortable: false,},
          { text: '本次发货件数', value: 'thisInnums' ,width: 100, sortable: false,},
          { text: '本次发货数量', value: 'thisDenums' ,width: 100, sortable: false,},
          { text: '是否发货完结', value: 'isComplete' ,width: 100, sortable: false,},
        ]
      },
      dischargeTypeList:[],
      auditHeaders:[
        {text: '审核结果', align: 'start', width:120,sortable: false, value: 'auditResult',},
        { text: '审核说明', value: 'rejectReason',width: 250, sortable: false,},
        { text: '审核人', value: 'auditBy' ,width: 120, sortable: false,},
        { text: '审核时间', value: 'auditTime' ,width: 250, sortable: false,},
      ],
      auditResultList:[{id:1,name:'通过'},{id:2,name:'不通过'}],
      audit:{
        dialog:false,
        backRefush:false,
        failDialog:false,
        rejectReason:'',
        rules:{
          required: value => (!!value || value === 0) || '必填.',
        },
        form:false
      },
    }
  },
  created() {
    this.getAppointment();
  },
  methods:{
    _hasButtonPermission(name){
      let buttonPriviledgeList = this.buttonPriviledgeList
      let hasButton =false
      for(let i=0;i<buttonPriviledgeList.length;i++){
        if(buttonPriviledgeList[i].name==name){
          if(buttonPriviledgeList[i].hasPriviledge=='Y'){
            return true
          } else {
            return false
          }
        }
      }
      return false
    },
    async getWarning() {
      let resp = await ConfigApi.getConfig({name: 'appointment.alert'});
      let data = resp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取配置失败" : msg;
        throw new Error(msg);
      }
      let warning = data.data;
      warning = warning.replaceAll('\n','<br/>');
      this.warning = warning;
    },
    async getAppointment() {
      let resp = await AppointmentApi.get({id: this.formData.id});
      let data = resp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取预约单信息失败" : msg;
        throw new Error(msg);
      }
      this.appointment = data.data;
    },
    back(){
      this.$emit("formCallback", {formStatus:'list', refresh:this.audit.backRefush})
    },
    watchOrderGoods(item){
      this.orderItem.item = item;
      this.orderItem.dialog = true;
    },
    handleAudit(){
      this.audit.dialog = true;
    },
    async auditPass() {
      let resp = await AppointmentApi.audit({appointmentId: this.appointment.id, auditResult: 1});
      let data = resp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "审核预约单失败" : msg;
        throw new Error(msg);
      }
      this.getAppointment();
      this.audit.dialog = false;
      this.audit.backRefush = true;
    },
    auditReject(){
      this.audit.failDialog = true;
    },
    async auditFail() {
      let resp = await AppointmentApi.audit({appointmentId: this.appointment.id, auditResult: 2, rejectReason:this.audit.rejectReason});
      let data = resp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "审核预约单失败" : msg;
        throw new Error(msg);
      }
      this.getAppointment();
      this.audit.dialog = false;
      this.audit.failDialog = false;
      this.audit.backRefush = true;
    }
  }
}
</script>

<style scoped>

</style>